import StyleConstants from '../../core/styles.constants';

/**
 * The rooms mockup gives every room card an icon and colour by "kind". Rooms carry no kind of their
 * own — only a capacity — so the kind is derived from that and used for the icon and colour ONLY.
 * The card's subtitle stays the room's real departments, so nothing invented is ever shown as text.
 */
export type RoomKind = 'single' | 'multi' | 'shared';

// A single-seat room is a focus spot; up to this many seats still reads as a focus room rather than
// an open work area (matches the mockup's own split, where 16 seats is still "focus, multiple").
const FOCUS_MULTI_MAX_CAPACITY = 16;

export const roomKindFor = (capacity: number): RoomKind => {
  if (capacity <= 1) {
    return 'single';
  }
  return capacity <= FOCUS_MULTI_MAX_CAPACITY ? 'multi' : 'shared';
};

const KIND_ACCENTS: Record<RoomKind, string> = {
  single: StyleConstants.ORANGE_COLOR,
  multi: StyleConstants.MEDIUM_BLUE_COLOR,
  shared: StyleConstants.DARK_BLUE_COLOR,
};

export const roomAccentFor = (capacity: number): string => KIND_ACCENTS[roomKindFor(capacity)];
